import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  PencilSquareIcon,
  TrashIcon,
  ArrowPathIcon,
} from "@heroicons/react/24/outline";
import {
  fetchCriteria,
  deleteCriteria,
} from "../../features/admin/CriteriaSlice";
import TableComponent from "../../components/TableComponent";
import { toast } from "react-toastify";
import CouponModal from "../../components/admin/CouponModal";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import CriteriaModal from "../../components/admin/CriteriaModal";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const userId = localStorage.getItem("userId");
const hasPermission = (requiredPermission) => {
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const Criteria = () => {
  const dispatch = useDispatch();
  const { criteria, status, error } = useSelector((state) => state.criteria);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentCoupon, setCurrentCoupon] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const handleOpenModal = (item = null) => {
    setCurrentCoupon(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentCoupon(null);
  };

  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
  };

  const handleDelete = async () => {
    try {
      await dispatch(deleteCriteria(deleteId)).unwrap();
      toast.success("Xóa sản phẩm thành công!");
      handleCloseDeleteModal();
    } catch (error) {
      toast.error("Đã xảy ra lỗi khi xóa mã thưởng!");
    }
  };

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCriteria());
    }
  }, [status, dispatch]);

  const headers = [
    {
      key: "key",
      label: "Mã tiêu chí",
      render: (item) => (
        <div>
          <p className="font-medium">{item.key}</p>
        </div>
      ),
    },
    {
      key: "name",
      label: "Tên tiêu chí",
      render: (item) => (
        <div>
          <p className="font-medium">{item.name}</p>
        </div>
      ),
    },
    {
      key: "point",
      label: "Điểm tiêu chí",
      render: (item) => (
        <div>
          <p className="font-medium">{item.point}</p>
        </div>
      ),
    },
  ];

  if (hasPermission("CRITERIA_UPDATE") || hasPermission("CRITERIA_DELETE")) {
    headers.push({ key: "setting", label: "Thao tác" });
  }

  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        {hasPermission("CRITERIA_UPDATE") && (
          <button
            disabled={item.status == "success"}
            onClick={() => handleOpenModal(item)}
            title="Chỉnh sửa"
            className="btn btn-outline btn-warning btn-sm px-3 my-1 rounded"
          >
            <PencilSquareIcon className="w-5 h-5" />
          </button>
        )}
        {hasPermission("CRITERIA_DELETE") && (
          <button
            disabled={item.type === "auto"}
            onClick={() => handleOpenDeleteModal(item.id)}
            title="Xem chi tiết"
            className="btn btn-outline btn-error btn-sm px-3 my-1 rounded"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        )}
      </div>
    ),
  };

  if (status === "loading") {
    return (
      <div className="flex justify-center items-center h-64">
        <ArrowPathIcon className="w-8 h-8 animate-spin text-blue-500" />
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="p-4 text-red-500 bg-red-50 rounded-md">
        Đã xảy ra lỗi: {error}
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold ">Quản lý tiêu chí</h1>
      </div>
      {hasPermission("CRITERIA_CREATE") && (
        <button
          onClick={() => handleOpenModal()}
          className="btn btn-success transition-colors px-4 py-2 rounded mb-6"
        >
          + Thêm tiêu chí
        </button>
      )}
      <div className="rounded-lg shadow">
        <TableComponent
          headers={headers}
          data={criteria}
          settings={tableSettings}
        />
      </div>

      {isModalOpen && (
        <CriteriaModal criteria={currentCoupon} onClose={handleCloseModal} />
      )}

      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDelete}
      />
    </div>
  );
};

export default Criteria;
